import { createAction, createSlice } from '@reduxjs/toolkit';

import namespace from './intlNameSpace';
import { DEFAULT_LANGUAGE, DEFAULT_LOCALE } from './intlResource';
import { type IntlResponse, type SupportedLocale } from './intlTypes';

const initialState = {
  language: DEFAULT_LANGUAGE,
  locale: DEFAULT_LOCALE,
  providerLocale: DEFAULT_LOCALE,
  messages: {} as Record<string, string>,
};

export const initLocale = createAction(`${namespace}/initLocale`);
export const fetchLocaleRequest = createAction(
  `${namespace}/fetchLocaleRequest`,
  (locale: SupportedLocale) => ({
    payload: { locale },
  }),
);
export const fetchLocaleError = createAction(`${namespace}/fetchLocaleError`, (error: unknown) => ({
  payload: { error },
}));

const intlSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {
    fetchLocaleSuccess: (state, action: { payload: IntlResponse }) => {
      const { language, locale, messages, providerLocale } = action.payload;
      state.language = language;
      state.locale = locale;
      state.providerLocale = providerLocale;
      state.messages = messages;
    },
  },
});

export const { fetchLocaleSuccess } = intlSlice.actions;

export default intlSlice.reducer;
